<script lang="ts">
	export { classes as class };
	let classes = 'w-6 h-6';
</script>

<svg
	class={classes}
	width="20"
	height="20"
	viewBox="0 0 20 20"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M16 8A6 6 0 1 1 4 8a6 6 0 0 1 12 0ZM9.85 5.1l-.72 1.56a.17.17 0 0 1-.14.1l-1.7.2a.18.18 0 0 0-.1.3l1.26 1.16a.17.17 0 0 1 .05.16l-.33 1.68c-.03.15.13.26.26.19l1.49-.84a.17.17 0 0 1 .17 0l1.5.84c.12.07.28-.04.25-.19l-.33-1.68a.17.17 0 0 1 .05-.16l1.25-1.16a.18.18 0 0 0-.1-.3l-1.7-.2a.18.18 0 0 1-.13-.1l-.72-1.56a.17.17 0 0 0-.31 0ZM10 15c1.43 0 2.83-.44 4-1.26v3.76a.5.5 0 0 1-.79.4L10 16l-3.21 1.9a.5.5 0 0 1-.79-.4v-3.76A6.97 6.97 0 0 0 10 15Z"
		fill="currentColor"
	/>
</svg>
